import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { ConfluencePages, UserRole } from '../enums'
import { UserManualProvider } from '../contexts/userManual'
import Redirect from '../pages/Redirect'
import LoadingState from '../components/LoadingState'

const Companies = lazy(() => import('../pages/pages/Companies'))
const Company = lazy(() => import('../pages/pages/Company'))
const CompanyJoin = lazy(() => import('../pages/pages/CompanyJoin'))

export default [
  {
    path: '/companies',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <UserManualProvider pageId={ConfluencePages.COMPANIES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <Companies />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/companies/join/:token',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <CompanyJoin />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  },
  {
    path: '/companies/:id',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN, UserRole.ADMIN, UserRole.INSTALLER, UserRole.USER]}>
        <UserManualProvider pageId={ConfluencePages.COMPANIES}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <Company />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: 'company/:id',
    element: <Redirect to="/companies/:id" />
  }
]
